import { deleteProductCart } from '../services/courses';
import { showError, showSuccess } from '../Utils/helper';
import { useTranslation } from 'react-i18next';

function UserCartData({ cartArr, countryId }) {
    const { t } = useTranslation();

    async function removeProductFromCart(_id) {
        const resp = await deleteProductCart(_id);
        if (resp.success) {
            showSuccess(t('alertMessage.courseDeleted'));
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } else {
            showError(t('alertMessage.wrong'));
        }
    }
    return (
        <div className="ro_body">
            <>
                {cartArr?.map((_cart) => {
                    return !_cart?.parent_name ? (
                        <div className="ro_row">
                            <div className="ro_inner">
                                <div className="ro_name">{_cart?.name}</div>
                                {_cart?.is_free ? (
                                    <div className="ro_price">{t('common.free')}</div>
                                ) : (
                                    <div className="ro_price">
                                        {countryId === 112
                                            ? t('course.price_in_kd', {
                                                  price: _cart?.price,
                                              })
                                            : countryId === 17
                                              ? t('course.price_in_bd', {
                                                    price: _cart?.price,
                                                })
                                              : t('course.price_in_jd', {
                                                    price: _cart?.price,
                                                })}
                                    </div>
                                )}
                            </div>
                            <a href="#" className="link" onClick={() => removeProductFromCart(_cart?.product_id)}>
                                {t('common.remove')}
                            </a>
                        </div>
                    ) : (
                        <div className="ro_row">
                            <div className="ro_inner">
                                <div className="ro_name">{_cart?.name}</div>
                                {_cart?.is_free ? (
                                    <div className="ro_price">{t('common.free')}</div>
                                ) : (
                                    <div className="ro_price">
                                        {countryId === 112
                                            ? t('course.price_in_kd', {
                                                  price: _cart?.price,
                                              })
                                            : countryId === 17
                                              ? t('course.price_in_bd', {
                                                    price: _cart?.price,
                                                })
                                              : t('course.price_in_jd', {
                                                    price: _cart?.price,
                                                })}
                                    </div>
                                )}
                            </div>
                            <a href="#" className="link" onClick={() => removeProductFromCart(_cart?.product_id)}>
                                {t('common.remove')}
                            </a>
                        </div>
                    );
                })}
            </>
        </div>
    );
}

export default UserCartData;
